export default __webpack_public_path__ + "static/media/badge_hour_flare.fdbd5aef.svg";